module.exports = __webpack_public_path__ + "static/media/left-arrow.4a275b72.svg";